<template>
  <div>
    <div class="page_title">
      <CustomBreadcrumb :suffix="`Order NO. ${orderId}`"/>
    </div>
    <div class="order_nav">
      <div class="nav_msg_total">
        <p class="nac_msg_name">Order total</p>
        <p class="nac_msg_num">{{ totalInfo.payAmount }}</p>
      </div>
      <div class="nav_msg_date">
        <p class="nac_msg_name">Orders Date</p>
        <p class="nac_msg_num">{{ orderDate }}</p>
      </div>
      <div class="nav_msg_status">
        <p class="nac_msg_name">Orders Status</p>
        <p class="nac_msg_num">{{ orderStatus }}</p>
      </div>
      <div class="nav_msg_address_width">
        <!-- <p class="nac_msg_name">
          Ship To
        </p>
        <p class="nac_msg_num" style="padding-top: 10px">
          <template>
            {{ tsStoreOrderAddress.name }}&nbsp;&nbsp;{{ tsStoreOrderAddress.lastname }}
            <br>
            {{ tsStoreOrderAddress.address }}&nbsp;
            <br>
            {{ tsStoreOrderAddress.city }}, {{ tsStoreOrderAddress.province }}, {{ tsStoreOrderAddress.countryName }}&nbsp;&nbsp;{{
              tsStoreOrderAddress.postCode
            }}
            <br>
            {{ tsStoreOrderAddress.areaCode }}-{{ tsStoreOrderAddress.phone }}
          </template>
        </p> -->
      </div>
      <div class="nav_msg_customer">
        <p class="nac_msg_name no_border">Customer</p>
        <p class="nac_msg_num no_border">{{ customer }}</p>
      </div>
    </div>
    <div class="order_item_list">
      <div class="order_item" v-for="(item,index) in skuList" :key="index">
        <el-divider v-if="index!==0"></el-divider>
        <div class="order_item_box">
          <div class="order_item_img"><img :src="item.skuImg"/></div>
          <div class="order_item_right">
            <div class="order_item_title">{{item.skuName}}</div>
            <div class="order_item_variant">{{item.finalSkuName}}</div>
            <div class="order_item_detail_border">
              <div class="order_item_detail">
                <div class="order_item_detail_title">Brand</div>
                <div class="order_item_detail_content">{{item.brandName}}</div>
              </div>
              <div class="order_item_detail">
                <div class="order_item_detail_title">Items</div>
                <div class="order_item_detail_content">{{item.serviceOrderWaitNum ? item.serviceOrderWaitNum : item.num}}</div>
              </div>
              <div class="order_item_detail">
                <div class="order_item_detail_title">Wholesale Price</div>
                <div class="order_item_detail_content">{{item.unitPrice}}</div>
              </div>
              <div class="order_item_detail">
                <div class="order_item_detail_title">Total</div>
                <div class="order_item_detail_content">{{item.commodityAmount}}</div>
              </div>
              <div class="order_item_detail">
                <div class="order_item_detail_title">Items Status</div>
                <div class="order_item_detail_content">{{handleOrderStatus(item.orderStatus,true)}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="order_track_box">
      <div class="order_track_information">Tracking Infomation</div>
      <div class="order_track_shipping_warehouse">Shipping Warehouse: <span>Brand Warehouse</span></div>
      <div class="order_track_shipping_warehouse_input">
        <el-input v-model="trackInfo.shippingAddress" placeholder="Brand warehouse shipping address"/>
        <div v-if="!trackInfo.shippingAddress" class="tips_error">Please enter shipping address</div>
      </div>
      <div class="order_track_information_detail">
        <div class="order_track_information_number">
          <div class="order_track_information_title">Tracking Number<span>*</span></div>
          <el-input v-model="trackInfo.logisticsNo" />
          <div v-if="!trackInfo.logisticsNo" class="tips_error">Please enter tracking number</div>
        </div>
        <div class="order_track_shipping_carrier">
          <div class="order_track_information_title">Shipping Carrier<span>*</span></div>
          <el-select
            v-model="trackInfo.shippingCarrier"
            filterable>
            <el-option
              v-for="item in shippingCarrierOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <div v-if="!trackInfo.shippingCarrier" class="tips_error">Please select shipping carrier</div>
        </div>
        <div class="order_track_cost">
          <div class="order_track_information_title">Cost ( USD ) <span>*</span></div>
          <el-input v-model="trackInfo.cost" />
          <div v-if="!trackInfo.cost" class="tips_error">Please enter cost</div>
        </div>
        <div class="order_track_invoice">
          <div class="order_track_information_title">Shipping invoice file<span>*</span></div>
          <el-upload
            class="upload-demo"
            :limit="1"
            :action="uploadApi"
            :on-success="handelSuccess"
            :on-remove="handleRemove"
            :file-list="fileList">
            <el-button size="small" type="primary">+ Upload</el-button>
             <template #file="{file}">
              <div class="el-upload-list__item">
                <span class="el-upload-list__item-name" @click="handleView(file)">
                  {{ file.name }}
                </span>
                <el-button size="small" type="text" @click="handleRemove(file)">Delete</el-button>
              </div>
            </template>
          </el-upload>
          <div v-if="trackInfo.shippingInvoiceFile && trackInfo.shippingInvoiceFile.length === 0" class="tips_error">Please upload Shipping invoice</div>
        </div>
      </div>
      <div class="submit" @click="fulfillItems">Fulfill items</div>
    </div>
     <el-dialog :visible.sync="reviewDialogVisible" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
        <div class="review-dialog-border">
          <div class="review-dialog-pass">
            <div class="review-dialog-tips">Shipping Confirmation</div>
            <div class="review-dialog-subtips">Please confirm your shipping information; edits are not allowed after 48 hours of submission.</div>
            <div class="review-dialog-content">
              <div class="review-dialog-content-row"><div class="review-dialog-content-title">Shipping Warehouse :</div><div>Brand Warehouse</div></div>
              <div class="review-dialog-content-row"><div class="review-dialog-content-title">Shipping Address :</div><div>{{trackInfo.shippingAddress}}</div></div>
              <div class="review-dialog-content-row"><div class="review-dialog-content-title">Tracking Number :</div><div>{{trackInfo.logisticsNo}}</div></div>
              <div class="review-dialog-content-row"><div class="review-dialog-content-title">Shipping Carrier :</div><div>{{trackInfo.shippingCarrier}}</div></div>
              <div class="review-dialog-content-row"><div class="review-dialog-content-title">Cost ($) :</div><div>{{trackInfo.cost}}</div></div>
              <div class="review-dialog-content-row"><div class="review-dialog-content-title">Shipping invoice file :</div><div class="upload_file_name" @click="reviewUploadFile">{{upLoadFileName}}</div></div>
            </div>
            <div class="review-dialog-action">
              <div v-loading="loading" class="review-dialog-confirm" @click="confirm">Confirm</div>
              <div v-loading="loading" class="review-dialog-cancel" @click="cancel">Cancel</div>
            </div>
          </div>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import CustomBreadcrumb from '../../components/custom-breadcrumb.vue'
import {orderStatusDis} from '../../../utils/status'
import {formateDate} from '@/components/formateEnDate.js'
import { getAction, postAction } from '../../../api/manage'
export default {
  components: {
    CustomBreadcrumb
  },
  data() {
    return {
      headers: {
        'x-access-token': Vue.ls.get('token')
      },
      fileList: [],
      uploadApi: '',
      trackInfo: {
        shippingWarehouse: 'Brand Warehouse',
        shippingAddress: '',
        logisticsNo: '',
        shippingCarrier: '',
        cost: '',
        shippingInvoiceFile: []
      },
      orderId: '',
      userInfo: {},
      address: '',
      customer: '', // customer信息
      tsStoreOrderAddress: {},
      tsStoreOrderInfo: {},
      orderStatus: '', // 订单状态
      orderDate: 'Jan,1,1970', // 订单时间
      skuList: [],
      totalInfo: {
        fobSubtotal: 0, // 订单离岸价
        cifSubTotal: 0, // 订单原始到岸价
        totalQuantity: 0, // 该订单下了多少个件商品
        totalPriceBefore: 0, // 该订单的优惠前金额
        totalPriceProductDicounted: 0, // 该订单商品优惠的金额
        totalPriceOrderDiscounted: 0, // 该订单  订单优惠金额
        totalPriceOrderDiscountedShopvidi: 0, // 该订单shopvidi优惠金额[优惠券]
        totalPrice: 0, // 该订单优惠后金额
        totalFreightBefore: 0, // 该订单物流 优惠前金额
        totalFreightDiscounted: 0, // 该订单物流优惠金额
        totalFreight: 0, // 物流实际费用
        subTotal: 0,
        payAmount: 0 // 订单实付金额
      },
      orderItemList: [],
      shippingCarrierOptions: [],
      reviewDialogVisible: false,
      loading: false,
      upLoadFileName: ''
    }
  },
  created() {
    this.getShippingChannel()
    this.uploadApi = process.env.API_URL + 'common/image'
    this.orderId = this.$route.query.orderId
    // 获取接口数据
    this.getShippingDetail()
  },
  methods: {
    getShippingChannel() {
      getAction('/order/api/v0.2/logistics/channel/details').then(response => {
        if (response.success) {
          if (response.result) {
            this.shippingCarrierOptions = response.result
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    confirm() {
      // 提交信息
      if (this.loading) {
        return
      }
      this.loading = true
      // 准备数据
      const submitObject = {}
      submitObject.orderId = this.orderId
      submitObject.shippingWarehouse = 'Brand Warehouse'
      submitObject.shippingAddress = this.trackInfo.shippingAddress
      submitObject.logisticsNo = this.trackInfo.logisticsNo
      submitObject.shippingCarrier = this.trackInfo.shippingCarrier
      submitObject.shippingInvoiceFile = this.trackInfo.shippingInvoiceFile[0]
      submitObject.shippingInvoiceFileName = this.upLoadFileName
      submitObject.cost = this.trackInfo.cost
      postAction('/order/api/v0.2/brand/orders/' + this.orderId + '/shipping-information', submitObject).then(response => {
        if (response.success) {
          this.$message.success(response.message)
          this.$router.push({path: 'Order'})
        } else {
          this.loading = false
          this.$message.warning(response.message)
        }
      })
    },
    cancel() {
      this.reviewDialogVisible = false
    },
    fulfillItems() {
      // 提交前先验证
      if (!this.trackInfo.shippingAddress || !this.trackInfo.logisticsNo || !this.trackInfo.shippingCarrier || !this.trackInfo.cost || (this.trackInfo.shippingInvoiceFile && this.trackInfo.shippingInvoiceFile.length === 0)) {
        return
      }
      this.reviewDialogVisible = true
    },
    reviewUploadFile() {
      this.handleView(this.fileList[0])
    },
    handleView(file) {
      if (file.response && file.response.result) {
        window.open(file.response.result)
      }
    },
    handelSuccess(response, file, fileList) {
      this.fileList.push(file)
      this.upLoadFileName = file.name
      this.trackInfo.shippingInvoiceFile.push(response.result)
    },
    handleRemove(file, fileList) {
      this.fileList = []
      this.upLoadFileName = ''
      this.trackInfo.shippingInvoiceFile = []
    },
    getShippingDetail() {
      getAction('/order/api/v0.2/brand/orders/' + this.orderId + '/details').then(response => {
        if (response.success) {
          if (response.result) {
            this.handlePayMethod(response.result.paymentMethod)
            this.handlePrice(response.result.tsStoreOrderInfo)
            this.handleAddress(response.result.tsStoreOrderAddress)
            this.handleCustomer(response.result.customer)
            if (response.result.skuItemsList) {
              this.skuList = response.result.skuItemsList.filter(e =>
                (!e.serviceOrderWaitNum && e.serviceOrderWaitNum !== 0) || e.serviceOrderWaitNum > 0
              )
            }
            this.tsStoreOrderInfo = response.result.tsStoreOrderInfo
            this.tsStoreOrderAddress = response.result.tsStoreOrderAddress
            this.trackInfo.shippingWarehouse = response.result.orderLogisticsSelfDelivery.shippingWarehouse
            this.trackInfo.logisticsNo = response.result.orderLogisticsSelfDelivery.logisticsNo
            this.trackInfo.shippingAddress = response.result.orderLogisticsSelfDelivery.shippingAddress
            this.trackInfo.shippingCarrier = response.result.orderLogisticsSelfDelivery.shippingCarrier
            this.trackInfo.cost = response.result.orderLogisticsSelfDelivery.cost
            if (response.result.orderLogisticsSelfDelivery.shippingInvoiceFile) {
              this.trackInfo.shippingInvoiceFile.push(response.result.orderLogisticsSelfDelivery.shippingInvoiceFile)
              const tempFileList = []
              const tempFileObject = {}
              tempFileObject.name = response.result.orderLogisticsSelfDelivery.shippingInvoiceFileName
              tempFileObject.response = {result: response.result.orderLogisticsSelfDelivery.shippingInvoiceFile}
              tempFileList.push(tempFileObject)
              this.fileList = tempFileList
              this.upLoadFileName = response.result.orderLogisticsSelfDelivery.shippingInvoiceFileName
            }
          }
        } else {
          this.$message.warning(response.message)
        }
      })
      this.handlePayMethod(5)
      this.handleAddress(this.tsStoreOrderAddress)
      this.handlePrice(this.tsStoreOrderInfo)
      this.handleCustomer(null)
    },
    handlePayMethod(paymentMethod) {
      if (paymentMethod) {
        if (paymentMethod === 1) {
          this.paymentMethod = 'Net 60 Payment Terms'
        } else if (paymentMethod === 2 || paymentMethod === 4) {
          this.paymentMethod = 'Pay With Card'
        } else if (paymentMethod === 3) {
          this.paymentMethod = 'Pay With ACH'
        } else if (paymentMethod === 5) {
          this.paymentMethod = 'Pay With PayPal'
        }
      }
    },
    handlePrice(orderInfo) {
      if (JSON.stringify(orderInfo) === '{}') {
        return
      }
      /**
       * Product discount ：   productDiscounted
       * Bulk order discount： orderDiscounted
       * Offered by ShopVidi：couponPrice
       * Shipping Fee (By Brand)：totalFreight
       * Total Amount  ：payAmount
       */
      /* if (orderInfo.totalPriceBefore) {
        this.totalPriceBefore = Number(orderInfo.totalPriceBefore).toFixed(2)
      } */
      if (orderInfo.productDiscounted) {
        this.totalInfo.totalPriceProductDicounted = Number(orderInfo.productDiscounted).toFixed(2)
      }
      if (orderInfo.orderDiscounted) {
        this.totalInfo.totalPriceOrderDiscounted = Number(orderInfo.orderDiscounted).toFixed(2)
      }
      if (orderInfo.couponPrice) {
        this.totalInfo.totalPriceOrderDiscountedShopvidi = Number(orderInfo.couponPrice).toFixed(2)
      }
      if (orderInfo.payAmount) {
        this.totalInfo.payAmount = Number(orderInfo.payAmount).toFixed(2)
      }

      // 物流试算
      if (orderInfo.totalFreightBefore) {
        this.totalInfo.totalFreightBefore = Number(orderInfo.totalFreightBefore).toFixed(2)
      }
      // 物流折扣
      if (orderInfo.freightDiscounted) {
        this.totalInfo.totalFreightDiscounted = Number(orderInfo.freightDiscounted).toFixed(2)
      }
      if (orderInfo.totalFreight) {
        this.totalInfo.totalFreight = Number(orderInfo.totalFreight).toFixed(2)
      }

      // 兼容历史数据（物流试算为空，物流折扣为负数）
      if (!orderInfo.totalFreightBefore && orderInfo.freightDiscounted && Number(orderInfo.freightDiscounted) < 0) {
        this.totalInfo.totalFreightBefore = Math.abs(Number(orderInfo.freightDiscounted)).toFixed(2)
        this.totalInfo.totalFreightDiscounted = '0.00'
      }

      if (orderInfo.goodsNum) {
        this.totalQuantity = orderInfo.goodsNum
      }
      if (orderInfo.orderStatus !== null) {
        this.orderStatus = this.handleOrderStatus(orderInfo.orderStatus, true)
      }
      if (orderInfo.createAt) {
        this.orderDate = formateDate(orderInfo.createAt)
      }
    },
    handleOrderStatus(t, flag) {
      if (flag && [3, 4, 5, 24, 52, 53, 54].includes(t)) {
        this.iconFlag = true
      }
      return orderStatusDis(t)
    },
    handleCustomer(customer) {
      if (customer === null || JSON.stringify(customer) === '{}') {
        return
      }
      if (customer.userName) {
        this.customer = customer.userName + '(Level  ' + customer.level + ')'
      }
    },
    handleAddress(addressInfo) {
      if (JSON.stringify(addressInfo) === '{}') {
        return
      }
      this.userInfo = addressInfo.name + '  ' + addressInfo.lastname + '   ' + addressInfo.areaCode + '-' + addressInfo.phone
      this.address = '【' + addressInfo.countryName + '】' + addressInfo.province + ' , ' + addressInfo.city + ' , ' + addressInfo.postCode + ' , ' + addressInfo.address
    }
  }
}
</script>

<style lang="less" scoped>
.order_nav {
  width: 96%;
  height: auto;
  border: 1px solid #e1e1e1;
  border-radius: 10px;
  margin-left: 20px;
  display: flex;
  .no_border {
    border: none !important;
  }
  .nav_msg_total,.nav_msg_date,.nav_msg_status,.nav_msg_address_width,.nav_msg_customer {
    flex-direction: column;
    padding: 20px 0 0 30px;
    min-width: 150px;
    width: 12%;
    height: 100%;
    .nac_msg_name {
      color: #5d5d5d;
      border-right: solid 1px #e1e1e1;
    }
    .nac_msg_num {
      padding-top: 10px;
      line-height: 24px;
      color: #262b2f;
      font-size: 14px;
      font-family: Graphik;
      font-weight: 400;
      border-right: solid 1px #e1e1e1;
    }
    .el-dropdown {
      margin-top: 10px;
      width: 80px;
    }
    .el-dropdown-link {
      color: #fff;
    }
  }
  .nav_msg_date{
    min-width: 190px;
  }
  .nav_msg_status{
    min-width: 160px;
  }
  .nav_msg_address_width{
    min-width: 300px;
    width: 30%;
  }
}
.order_item_list{
  width: 96%;
  height: auto;
  max-height: 400px;
  border-radius: 10px;
  border: 1px solid #E1E1E1;
  margin: 10px 0px 10px 20px ;
  padding-bottom: 20px;
  overflow-y:auto;
  .order_item{
    padding: 20px 30px 0px 30px;
    .order_item_box{
      display: flex;
      align-items: center;
      .order_item_img{
        width: 120px;
        height: 120px;
        img{
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .order_item_right{
        margin-left: 20px;
        .order_item_variant{
          margin-top: 6px;
        }
        .order_item_detail_border{
          margin-top: 20px;
          display: flex;
          align-items: center;
          .order_item_detail{
            margin-right: 80px;
            .order_item_detail_title{

            }
            .order_item_detail_content{
              margin-top: 10px;
            }
          }
        }
      }
    }
  }
}
.order_track_box{
  width: 96%;
  border-radius: 10px;
  border: 1px solid #E1E1E1;
  margin-left: 20px;
  padding: 20px;
  .order_track_information{
    color: #262b2f !important;
  }
  .order_track_shipping_warehouse{
    margin-top: 26px;
    color: #262b2f !important;
    span{
      margin-left: 5px;
    }
  }
  .order_track_shipping_warehouse_input{
    margin-top: 13px;
    max-width: 758px;
  }
  .order_track_information_detail{
    display: flex;
    margin-top: 20px;
    span{
      margin-left: 10px;
      color: #FB541C;
    }
    .order_track_information_number,.order_track_shipping_carrier,.order_track_cost,.order_track_invoice{
      margin-right: 20px;
      /deep/ .el-input{
        min-width: 228px;
      }
      .order_track_information_title{
        margin-bottom: 10px;
      }
    }
    .order_track_cost{
      /deep/ .el-input{
        min-width: 160px;
      }
    }
  }
}
.tips_error{
  color: #FB541C;
  margin-top: 5px;
}
.el-divider--horizontal{
  margin: 0px 0px 20px 0px !important;
}
.upload-demo{
  display: flex;
  align-items: center;
}
.submit{
  background: #262b2f;
  color: #FFFFFF;
  width: 418px;
  height: 40px;
  border-radius: 5px;
  margin-top: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.review-dialog-border{
  width: 96%;
  margin:0 auto;
}
.review-dialog-tips{
  width: 100%;
  margin: 0 auto;
  padding: 20px 0px 10px 0px;
  font-size: 14px;
  font-family: Satoshi-Bold !important;
  line-height: 20px;
  color: #000000;
  opacity: 1;
  span{
    margin-left: 10px;
    font-size: 14px;
    color: #5D5D5D;
    font-family: Satoshi-Regular;
  }
}
.review-dialog-subtips,.review-dialog-content{
  width: 95%;
  margin: 0 auto;
  font-family: Satoshi-Medium !important;
  color: #262B2F;
}
.review-dialog-content{
  margin-top: 20px;
  .review-dialog-content-row{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .review-dialog-content-title{
      color: #262B2F;
      font-family: Satoshi-Medium !important;
      min-width: 150px;
    }
  }
}
.review-dialog-action{
  width: 95%;
  margin:0 auto;
  margin-top: 20px;
  padding-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .review-dialog-cancel,.review-dialog-confirm{
    width: 48%;
    height: 41px;
    border: 1px solid #707070;
    opacity: 1;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Satoshi-Medium !important;
    cursor: pointer;
  }
  .review-dialog-cancel{
    background:#FFFFFF
  }
  .review-dialog-confirm{
    background:#262B2F;
    color:#FFFFFF
  }
}
.el-upload-list__item{
  display: flex;
  align-items: center;
  span{
    color: #262B2F !important;
    margin-right: 10px;
  }
}
.upload_file_name{
  text-decoration: underline;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/shipping/shipping-detail.vue